<template>
	<svg width="80" height="80" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path
			d="M35.3375 10H45.25V55.4225C41.0187 56.2909 36.7119 56.7389 32.3925 56.76C20.2875 56.7475 13.9875 51.34 13.9875 40.955C13.9875 30.955 20.67 24.455 31.0275 24.455C32.4801 24.4267 33.9299 24.5949 35.3375 24.955V10ZM35.3375 32.855C34.2599 32.4995 33.1295 32.3304 31.995 32.355C26.995 32.355 24.0875 35.4125 24.0875 40.77C24.0875 45.9875 26.855 48.8675 31.9325 48.8675C33.0721 48.8672 34.2101 48.7837 35.3375 48.6175V32.8675V32.855Z"
			fill="#235B46" />
		<path
			d="M61 25.1475V47.8975C61 55.73 60.4125 59.495 58.6925 62.7425C56.9371 66.0445 54.0667 68.6163 50.5925 70L41.3975 65.6675C44.738 64.5236 47.5358 62.1818 49.25 59.095C50.665 56.2925 51.1125 53.045 51.1125 44.5025V25.1475H61Z"
			fill="#235B46" />
		<path d="M61.0125 10.05H51.1025V20.1201H61.0125V10.05Z" fill="#235B46" />
	</svg>
</template>